import { TextField } from "@mui/material";
import { MONO } from "../helpers";

/** A six-digit authenticator code. Digits only; the phone's number pad. */
export default function CodeField({ value, onChange, disabled, autoFocus = true }: {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  autoFocus?: boolean;
}) {
  return (
    <TextField
      label="6-digit code"
      value={value}
      fullWidth
      autoFocus={autoFocus}
      disabled={disabled}
      onChange={(event) => onChange(event.target.value.replace(/\D/g, "").slice(0, 6))}
      slotProps={{
        htmlInput: {
          inputMode: "numeric",
          autoComplete: "one-time-code",
          maxLength: 6,
          style: { fontFamily: MONO, fontSize: 20, letterSpacing: "0.35em" },
        },
      }}
    />
  );
}
